"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _string_utility = require("../../../../packages/common-utilities/src/string_utility");

var _string_utility2 = _interopRequireDefault(_string_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Modal = function (_PureComponent) {
  _inherits(Modal, _PureComponent);

  function Modal() {
    _classCallCheck(this, Modal);

    return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
  }

  _createClass(Modal, [{
    key: "getModalContainer",
    value: function getModalContainer() {
      var _props = this.props,
          clickYesButton = _props.clickYesButton,
          closeModal = _props.closeModal,
          type = _props.type,
          hideCloseModalButton = _props.hideCloseModalButton,
          gaiaRedirectUrl = _props.gaiaRedirectUrl;

      var buttons = [];
      buttons.push({ type: "yes", action: clickYesButton });
      if (!hideCloseModalButton) {
        buttons.push({ type: "no", action: closeModal });
      }

      if (type === "loading") {
        return _react2.default.createElement("img", { id: "loadingIndicator", className: "centerPosition", src: gaiaRedirectUrl + "/images/spinner_grey.gif" });
      }

      if (type === "loading-bg-w") {
        return _react2.default.createElement("img", { id: "loadingIndicator", className: "centerPosition", src: gaiaRedirectUrl + "/images/spinner.gif" });
      }

      if (type === "info") {
        return _react2.default.createElement(
          "div",
          { className: "headerModalContent font-black" },
          _react2.default.createElement(
            "h2",
            null,
            this.props.modalContent || ''
          )
        );
      }

      if (type === "favorite") {
        return _react2.default.createElement(
          "div",
          { className: "headerModalContent font-black" },
          _react2.default.createElement(
            "h2",
            null,
            _string_utility2.default.renderFormattedLabel(type + "-modal-content", type + "-modal-content")
          ),
          _react2.default.createElement("img", { id: "loadingIndicator", className: "centerPosition", style: { top: '60%' }, src: gaiaRedirectUrl + "/images/spinner.gif" })
        );
      }

      return _react2.default.createElement(
        "div",
        { className: "headerModalContainer" },
        _react2.default.createElement(
          "div",
          { className: "headerModalContent font-light" },
          _string_utility2.default.renderFormattedLabel(type + "-modal-content", type + "-modal-content")
        ),
        buttons.map(function (button) {
          return _react2.default.createElement(
            "div",
            { className: "headerModalButton" },
            _react2.default.createElement(
              "div",
              { className: "centerPosition" },
              _react2.default.createElement(
                "button",
                { "data-testid": type + "-modal-" + button.type,
                  className: "modalButton font-regular",
                  onClick: button.action },
                _string_utility2.default.renderFormattedLabel(type + "-modal-button-" + button.type, type + "-modal-button-" + button.type)
              )
            )
          );
        })
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          display = _props2.display,
          closeModal = _props2.closeModal;

      var modalStyling = {
        display: display,
        position: "absolute",
        zIndex: 3
      };

      return _react2.default.createElement(
        "div",
        { "data-testid": "global-modal", className: "global-modal", style: modalStyling },
        _react2.default.createElement(
          "div",
          { className: "globalModal" },
          _react2.default.createElement(
            "div",
            { id: "globalModal", className: "headerModal" },
            _react2.default.createElement(
              "div",
              { className: "headerModalClose", onClick: closeModal },
              _react2.default.createElement("span", { className: "crossImage float-right margin-all-5" })
            ),
            this.getModalContainer()
          )
        )
      );
    }
  }]);

  return Modal;
}(_react.PureComponent);

exports.default = Modal;